import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { CrmPermissionStateService } from '../auth/services/crm-permission-state.service';

/** Permission module key for My Commission. Applies to every role — Administrators
 *  included — so access comes from the permissions payload alone. */
export const MY_COMMISSIONS_PERMISSION_KEY = 'my_commissions';

export const matchMyCommissionsRoute: CanMatchFn = () => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const permissionState = inject(CrmPermissionStateService);
  const router = inject(Router);

  return permissionState.hasSupportedInModule(MY_COMMISSIONS_PERMISSION_KEY)
    ? true
    : router.parseUrl('/dashboard');
};
